import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'
import momentHelper from 'scoreboard/components/moment-helper'
import SuccessDialog from 'scoreboard/components/success-dialog'

const ExportScheduledConfirmation = SuccessDialog.extend({

	initialize: function (options) {
		this.options = options || {}
	},

	render: function () {
		SuccessDialog.prototype.render.apply(this, arguments)
		return this
	},

	context: function () {
		let nextRunTime = momentHelper.formatDateTime(this.options.nextRunTime)
		let message = i18n.get('common.export.scheduled.confirmation.message',
			highlight(nextRunTime))
		return {
			title: i18n.get('common.export.scheduled.confirmation.title'),
			message
		}
	},

	done: function () {
		this.trigger('done')
	}
})

export default ExportScheduledConfirmation
ExportScheduledConfirmation.__filename__ = 'components/export/export-scheduled-confirmation.js'
